module.exports = __webpack_public_path__ + "assets/chat.c2f47c80.svg";